import Vue from 'vue'
import App from './App.vue'
import { Collapse, Col, Row } from 'ant-design-vue';
import router from './router/index'

Vue.use(Collapse);
Vue.use(Row)
Vue.use(Col)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
